import script from "./Animation.vue?vue&type=script&setup=true&lang=js"
export * from "./Animation.vue?vue&type=script&setup=true&lang=js"

import "./Animation.vue?vue&type=style&index=0&id=2aa5d20d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa5d20d"]])

export default __exports__